import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import OwnerRoute from "@/components/OwnerRoute";
import AdminRoute from "@/components/AdminRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PublicMenu from "@/pages/PublicMenu";
import AcceptInvite from "@/pages/AcceptInvite";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import MenuPage from "@/pages/dashboard/MenuPage";
import WebsitePreview from "@/pages/dashboard/WebsitePreview";
import OrderFormBuilder from "@/pages/dashboard/OrderFormBuilder";
import Inventory from "@/pages/dashboard/Inventory";
import DailyInventory from "@/pages/dashboard/DailyInventory";
import Sales from "@/pages/dashboard/Sales";
import Employees from "@/pages/dashboard/Employees";
import Customers from "@/pages/dashboard/Customers";
import Orders from "@/pages/dashboard/Orders";
import GiftCards from "@/pages/dashboard/GiftCards";
import StaffAccounts from "@/pages/dashboard/StaffAccounts";
import Salaries from "@/pages/dashboard/Salaries";
import WebsiteBuilder from "@/pages/dashboard/WebsiteBuilder";
import Forecasting from "@/pages/dashboard/Forecasting";
import BusinessProfile from "@/pages/dashboard/BusinessProfile";
import Billing from "@/pages/dashboard/Billing";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminClients from "@/pages/admin/AdminClients";
import AdminClientDetail from "@/pages/admin/AdminClientDetail";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/m/:slug" element={<PublicMenu />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminLayout />
                </AdminRoute>
              }
            >
              <Route index element={<AdminOverview />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="clients/:id" element={<AdminClientDetail />} />
            </Route>
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="menu" element={<MenuPage />} />
              <Route path="website" element={<WebsitePreview />} />
              <Route path="website-builder" element={<OwnerRoute><WebsiteBuilder /></OwnerRoute>} />
              <Route path="salaries" element={<Salaries />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="daily-inventory" element={<DailyInventory />} />
              <Route path="sales" element={<Sales />} />
              <Route path="employees" element={<Employees />} />
              <Route path="customers" element={<Customers />} />
              <Route path="orders" element={<Orders />} />
              <Route path="order-form" element={<OwnerRoute><OrderFormBuilder /></OwnerRoute>} />
              <Route path="gift-cards" element={<GiftCards />} />
              <Route path="staff-accounts" element={<OwnerRoute><StaffAccounts /></OwnerRoute>} />
              <Route path="forecasting" element={<Forecasting />} />
              <Route path="profile" element={<BusinessProfile />} />
              <Route path="billing" element={<OwnerRoute><Billing /></OwnerRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
